import type { FC } from 'react';

import { Heading, IconLoader, IconList as SparkyIconList, Stack } from '@eneco/sparky';
import { ChevronRightIcon } from '@eneco/sparky/icons';
import { IconListRendering } from '@sitecore/types/manual/IconList';

const IconList: FC<IconListRendering> = ({ fields }) => {
  return (
    <Stack direction="column" gap="2">
      {fields?.title?.value && (
        <Stack.Item>
          <Heading size="3XS" as="h2">
            {fields?.title?.value}
          </Heading>
        </Stack.Item>
      )}
      <Stack.Item>
        <SparkyIconList>
          {fields.items.map(item => {
            if (!item?.fields?.text?.value) return null;

            return (
              <SparkyIconList.Item
                key={item.id}
                icon={
                  <IconLoader
                    iconName={item?.fields?.icon?.name}
                    fallbackIcon={<ChevronRightIcon />}
                    color={item?.fields?.color?.value ?? 'currentColor'}
                  />
                }>
                {item.fields.text.value}
              </SparkyIconList.Item>
            );
          })}
        </SparkyIconList>
      </Stack.Item>
    </Stack>
  );
};

export { IconList };
export default IconList;
